// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.item[data-v-87415322]{\r\n\tmin-height: 80px;\n}\n.header[data-v-87415322] {\r\n\tcolor: var(--main-gray-5);\n}\n.content[data-v-87415322]{\r\n\tfont-size: 20px;\r\n\tfont-weight: bold;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
